import React, { memo, useEffect, useState } from 'react'
import Chip from '@material-ui/core/Chip'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import parse from 'autosuggest-highlight/parse'
import match from 'autosuggest-highlight/match'
import LOG from '../../logging/Logger'
import {
  MAX_LENGTH_TAG_NAME,
  TAGS_DISPLAY_LIMIT,
  TAGS_MAX
} from '../../data/limits'

export default memo(
  ({ className, label = 'Tags', getAutocompleteTags, tags, onSetTags }) => {
    LOG.debug('Render: TodoTagInput')

    const [open, setOpen] = useState(false)
    const [options, setOptions] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
      setLoading(true)
      setOptions(getAutocompleteTags().sort())
      setLoading(false)
    }, [getAutocompleteTags])

    const handleSetTags = values => {
      if (values.length > TAGS_MAX) {
        setError(TAGS_MAX + ' Tag limit reached')
      } else {
        setError(null)
        onSetTags(values)
      }
    }

    return (
      <div className={className}>
        <Autocomplete
          multiple
          open={open}
          onOpen={() => {
            setOpen(true)
          }}
          onClose={() => {
            setOpen(false)
          }}
          onBlur={() => setError(null)}
          loading={loading}
          options={options}
          freeSolo
          value={tags}
          limitTags={TAGS_DISPLAY_LIMIT}
          onChange={(event, values) => handleSetTags(values)}
          filterSelectedOptions
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                color='primary'
                variant='outlined'
                label={option}
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={params => (
            <TextField
              {...params}
              label={label}
              inputProps={{
                ...params.inputProps,
                'aria-label': 'todo-tags',
                'data-lpignore': 'true',
                maxLength: MAX_LENGTH_TAG_NAME
              }}
              error={error ? true : undefined}
              helperText={error}
            />
          )}
          renderOption={(option, { inputValue }) => {
            const matches = match(option, inputValue)
            const parts = parse(option, matches)

            return (
              <div>
                {parts.map((part, index) => (
                  <span
                    key={index}
                    style={{
                      fontColor: 'black',
                      fontWeight: part.highlight ? 900 : null
                    }}
                  >
                    {part.text}
                  </span>
                ))}
              </div>
            )
          }}
        />
      </div>
    )
  }
)
